<template>
  <section id="lab-documents-file-view">
    <div class="all-cases-view">
      <div class="container-small-table">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <div class="breadcrumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item :to="{ path: '/labs-documents' }"
                    >Lab Documents</el-breadcrumb-item
                  >

                  <el-breadcrumb-item>
                    {{ $route.params.folder_name }}
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li v-if="hasPermission('lab_documents', 'add')">
                  <el-button
                    class="btn button-with-icon"
                    @click="dialogVisible = true"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/lab-documents/upload-icon.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/lab-documents/upload-icon-active.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    Upload Files
                    <span></span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    :class="foldersView == 'list' ? 'active' : ''"
                    @click="foldersView = 'list'"
                  >
                    <span>
                      <img
                        src="@/assets/images/icons/lab-documents/listing-inactive.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/lab-documents/listing-active.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    :class="foldersView == 'grid' ? 'active' : ''"
                    @click="foldersView = 'grid'"
                  >
                    <span>
                      <img
                        src="@/assets/images/icons/lab-documents/grid-listing-inactive.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/lab-documents/grid-listing-active.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
        <div v-loading="loading">
          <div v-if="tableData && tableData.length">
            <div class="grid-view-block" v-if="foldersView == 'grid'" >
              <div class="grid-scroll" >
                <div class="single-grid-view-block">
                  <div
                    v-for="(item, index) of tableData"
                    :key="index"
                    class="single-grid-view-block-col"
                  >
                    <div class="icon-block">
                      <img
                        v-if="item.metadata.original_name.search('csv') != -1"
                        src="@/assets/images/icons/lab-documents/lab-word-icon.svg"
                        alt="document"
                      />
                      <img
                        v-else
                        src="@/assets/images/icons/lab-documents/lab-pdf-icon.svg"
                        alt="document"
                      />

                      <div class="action-buttons">
                        <el-button
                          v-if="item.metadata.original_name.search('pdf') != -1"
                          class="folder-btn"
                          @click="onPreviewFile(item.key)"
                        >
                          <img
                            src="@/assets/images/icons/lab-documents/view.svg"
                            alt="icon"
                          />
                        </el-button>
                        <el-button v-if="hasPermission('lab_documents', 'add')"
                          class="folder-btn"
                          @click="onDownloadFile(item.key)"
                        >
                          <img
                            src="@/assets/images/icons/lab-documents/download-btn.svg"
                            alt="delete-btn"
                          />
                        </el-button>
                        <el-button v-if="hasPermission('lab_documents', 'add')"
                          class="folder-btn"
                          @click="onDeleteFile(item._id)"
                        >
                          <img
                            src="@/assets/images/icons/lab-documents/delete-btn.svg"
                            alt="delete-btn"
                          />
                        </el-button>
                      </div>
                    </div>

                    <div class="content">
                      <h4 class="title">{{ item.metadata.original_name }}</h4>
                      <div class="sub-text">
                        <div class="created_on">
                          {{
                            momentWithTimezone(
                              item.created_at,
                              "MM-DD-yyyy hh:mm A"
                            )
                          }}
                        </div>
                        <div class="file-size">
                          {{ getFileSize(item.metadata.file_size) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="primary-content-view-new"
              v-else-if="foldersView == 'list'"
            >
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table
                  :data="tableData"
                  class="labdocfileslisting"
                  height="calc(100vh - 200px)"
                >
                  <el-table-column prop="name" label="Name" width="500">
                    <template v-slot="scope">
                      <div class="name-accession">
                        <span class="order-files">
                          <img
                            v-if="
                              scope.row.metadata.original_name.search('csv') !=
                              -1
                            "
                            src="@/assets/images/icons/lab-documents/lab-word-icon.svg"
                            alt="document"
                          />
                          <img
                            v-else
                            src="@/assets/images/icons/lab-documents/lab-pdf-icon.svg"
                            alt="document"
                          />
                        </span>
                        <span
                          @click="goToOrdersView(scope.row._id)"
                          class="text-center order-files-name-value"
                        >
                          {{ scope.row.metadata.original_name }}
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="date_created"
                    label="Date Created"
                    min-width="250"
                  >
                    <template v-slot="scope">
                      {{
                        momentWithTimezone(
                          scope.row.created_at,
                          "MM-DD-yyyy hh:mm A"
                        )
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="size" label="Size" width="200">
                    <template v-slot="scope">
                      <span>
                        {{ getFileSize(scope.row.metadata.file_size) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Actions" width="110">
                    <template v-slot="scope">
                      <ul class="listings__action-buttons">
                        <li v-if="hasPermission('lab_documents', 'add')">
                          <el-button
                            class="view-button"
                            @click="onDownloadFile(scope.row.key)"
                          >
                            <img
                              class="action-active"
                              src="@/assets/images/icons/actions/download-new-active.svg"
                              alt="icon"
                            />
                            <img
                              class="action-inactive"
                              src="@/assets/images/icons/actions/download-new.svg"
                              alt="icon"
                            />
                          </el-button>
                        </li>
                        <li v-if="hasPermission('lab_documents', 'add')">
                          <el-button
                            class="view-button"
                            @click="onDeleteFile(scope.row._id)"
                          >
                            <img
                              class="action-active"
                              src="@/assets/images/icons/actions/delete-active.svg"
                              alt="icon"
                            />
                            <img
                              class="action-inactive"
                              src="@/assets/images/icons/actions/delete-deactive.svg"
                              alt="icon"
                            />
                          </el-button>
                        </li>
                        <li >
                          <el-button
                            class="view-button"
                            @click="onPreviewFile(scope.row.key)"
                          >
                            <img
                              src="@/assets/images/icons/lab-documents/view.svg"
                              alt="icon"
                            />
                          </el-button>
                        </li>
                      </ul>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              class="listings listings__pagination"
              v-if="getAllDocuments && getAllDocuments.total > 10"
            >
              <el-pagination
                v-model:currentPage="page"
                v-model:page-size="pageSize"
                :page-sizes="[10, 25, 50, 100]"
                layout=" prev, pager, next, jumper, sizes ,total"
                :total="getAllDocuments.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
          <div class="no-data-block" v-else>
            <div class="bg-image">
              <img
                src="@/assets/images/backgrounds/no-data-img.png"
                class="bg-image"
                alt="No data Background"
              />
              <div class="no-data-content">
                <h3>No data</h3>
              </div>
            </div>
          </div>
        </div>

        <div class="default-modal">
          <el-dialog
            v-model="dialogVisible"
            width="35%"
            :before-close="handleClose"
            v-loading="modalLoading"
          >
            <div class="dialog-header">
              <span class="header-part"> ADD FILE </span>

              <el-button
                size="medium"
                class="el-white"
                type="info"
                plain
                @click="dialogVisible = false"
              >
                <img
                  src="@/assets/images/icons/cases/close-btn.svg"
                  alt="icon"
                />
              </el-button>
            </div>
            <span>
              <el-form>
                <el-row :gutter="20" class="popup-date pb-0">
                  <el-col :span="24">
                    <div class="upload-files-alignment-block">
                      <div class="upload-files-alignment">
                        <el-upload
                          class="upload-demo"
                          drag
                          action
                          :on-change="handleUpload"
                          :on-remove="handleRemove"
                          :auto-upload="false"
                          :file-list="files"
                          accept=".pdf,.csv"
                          :show-file-list="false"
                          :limit="1"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload-text-align">
                            <div class="el-upload__text-img">
                              <img
                                src="@/assets/images/icons/attachments-icon.svg"
                                alt=""
                              />
                            </div>
                            <div class="el-upload__text">
                              <h3>Drag & drop file here</h3>
                              <p>your file here, or browse</p>
                            </div>
                          </div>
                        </el-upload>
                        <p
                          class="err"
                          v-if="
                            getFileCreateValidationErrors &&
                            getFileCreateValidationErrors.file
                          "
                        >
                          {{ getFileCreateValidationErrors.file }}
                        </p>
                      </div>
                      <div class="sample-attachment-upload-file-block">
                        <div v-for="(file, index) in files" :key="index">
                          <ul class="sample-attachment-upload-file">
                            <li>
                              <div class="file-name-attachment mb-10">
                                <img
                                  src="@/assets/images/icons/attachments/attachments_1.svg"
                                  alt=""
                                />
                                <p>{{ file.name }}</p>
                                <el-button
                                  type="text"
                                  @click="remove"
                                  class="btn-close"
                                  size="sm"
                                >
                                  <img
                                    class="hover"
                                    src="@/assets/images/icons/attachments/attachment-success.svg"
                                    alt=""
                                  />
                                  <img
                                    src="@/assets/images/icons/attachments/remove-button.svg"
                                    alt=""
                                    class="without-hover"
                                  />
                                </el-button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="upload-files-alignment">
                      <div class="dialog-footer pt-0">
                        <el-button
                          class="blue-save-button"
                          @click="submitFileUploadDetails"
                          :loading="loading"
                          :disabled="checkDisable"
                        >
                          <img
                            src="@/assets/images/icons/lab-documents/upload-icon-active.svg"
                            alt="icon"
                          />
                          UPLOAD
                          <span class="el-icon-upload2 submit-btn-arrow"></span>
                        </el-button>
                      </div>
                      <p
                        class="err"
                        v-if="
                          getFileCreateValidationErrors &&
                          getFileCreateValidationErrors.critical_error
                        "
                      >
                        {{ getFileCreateValidationErrors.critical_error }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </span>
          </el-dialog>
        </div>
      </div>
      <el-dialog
        title="Confirmation"
        v-model="showConfirmationModal"
        width="30%"
        center
      >
        <p>Are you sure you want to delete this file?</p>
        <template v-slot:footer>
          <el-button @click="cancelDelete">Cancel</el-button>
          <el-button type="primary" @click="confirmDelete">Confirm</el-button>
        </template>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import LabDocumentsHelper from "@/mixins/LabDocumentsHelper";
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  mixins: [LabDocumentsHelper,UserPermissionsHelper],
  data() {
    return {
      search_string: "",
      foldersView: "grid",
      loading: false,
      modalLoading: false,
      dialogVisible: false,
      pageSize: 25,
      page: 1,
      pageSizes: [5, 10, 15, 20],
      tableData: [],
      files: [],
      file: null,
      category_id: this.$route.params.folder_id,
      form: {
        file: "",
        file_size: 0,
        file_type: "",
      },
      showConfirmationModal: false,
      fileIdToDelete: null,
    };
  },
  async mounted() {
    await this.getCategoryFiles();
  },
  computed: {
    ...mapGetters("labDocuments", [
      "getAllDocuments",
      "getUploadFileData",
      "getUploadFileStatus",
      "getDownloadFileData",
      "getDeleteFileStatus",
      "getFileCreateValidationErrors",
      "getLabDocumentPreview",
    ]),
    ...mapGetters("cases", ["getAttachmentUploadStatus"]),
    ...mapGetters("errors", ["getMessage"]),

    checkDisable() {
      if (this.files && this.files.length === 1) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async onPreviewFile(file) {
      try {
        let params = {
          key: file,
        };
        await this.$store.dispatch("labDocuments/previewDocumentFile", params);
        if (this.getLabDocumentPreview) {
          let url = this.getLabDocumentPreview.data;
          window.open(url, "_blank");
        } else {
          errorNotification("Error while preview document");
        }
      } catch (err) {
        console.log(err);
      }
    },
    remove(index) {
      this.files.splice(index, 1);
    },
    handleClose() {
      this.dialogVisible = false;
    },

    getFileSize(kbs) {
      let mb = parseInt(kbs) / 1024;
      return mb >= 1024
        ? parseFloat(kbs / (1024 * 1024)).toFixed(2) + " MB"
        : parseFloat(mb).toFixed(2) + " KB";
    },
    async getCategoryFiles() {
      this.loading = true;
      let params = { limit: this.pageSize, page: this.page };
      if (this.$route.params.folder_id) {
        params.category = this.$route.params.folder_id;
      }
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      await this.$store.dispatch("labDocuments/fetchDocuments", params);
      this.tableData = this.getAllDocuments.data;
      this.loading = false;
    },
    handleRemove(file) {
      console.log(file);
      this.files = [];
    },
    handleUpload(file) {
      file.status = "success";
      file.percentage = 100;
      this.files = [];
      this.files.push(file);
      this.file = file.raw;
      this.form.file = file.raw.name;
      this.form.file_type = file.raw.type;
      this.form.file_size = file.raw.size;
    },
    async submitFileUploadDetails() {
      try {
        this.loading = true;
        let params = {
          category_id: this.category_id,
          form_data: this.form,
        };

        // stores file meta data and gets presigned url
        await this.$store.dispatch("labDocuments/uploadFile", params);

        if (this.getUploadFileData) {
          // upload file using presigned url
          await this.$store.dispatch("cases/uploadDocumentToGeneratedUrl", {
            upload_url: this.getUploadFileData.target_url,
            file: this.file,
          });

          if (this.getAttachmentUploadStatus) {
            // update the uploaded file status
            await this.$store.dispatch("labDocuments/updateFileStatus", {
              document_id: this.getUploadFileData.hash,
            });
            this.files = [];
            this.form = {};
            if (this.getUploadFileStatus) {
              successNotification("File uploaded successfully");
              this.dialogVisible = false;
              window.location.reload();
              this.getCategoryFiles();
            } else {
              errorNotification("Error in uploading file");
            }
          }
        }
        this.loading = false;
      } catch (err) {
        this.errorNotify(this.getMessage);
        console.log(err);
      }
    },

    async onDownloadFile(key) {
      try {
        await this.$store.dispatch("labDocuments/fetchDownloadFileData", {
          key: key,
        });
        if (this.getDownloadFileData.download_url) {
          window.open(this.getDownloadFileData.download_url);
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error in downloading File",
          });
        }
      } catch (error) {
        this.$notify.error({
          title: "Error",
          message: "Error in downloading File",
        });
        console.log(error);
      }
    },
    showDeleteConfirmation(id) {
      this.fileIdToDelete = id;
      this.showConfirmationModal = true;
    },
    cancelDelete() {
      this.showConfirmationModal = false;
      this.fileIdToDelete = null;
    },
    async confirmDelete() {
      try {
        await this.$store.dispatch("labDocuments/deleteDocumentFile", {
          document_id: this.fileIdToDelete,
        });

        if (this.getDeleteFileStatus) {
          successNotification("File deleted successfully");
          await this.getCategoryFiles();
        } else {
          errorNotification("Error in deleting File");
        }
      } catch (error) {
        errorNotification("Error in deleting File");
        console.log(error);
      } finally {
        this.showConfirmationModal = false;
        this.fileIdToDelete = null;
      }
    },
    async onDeleteFile(id) {
      this.fileIdToDelete = id;
      this.showConfirmationModal = true;
    },
    async handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      await this.getCategoryFiles();
    },
    async handleCurrentChange(val) {
      this.page = val;
      await this.getCategoryFiles();
    },
  },
};
</script>
<style lang="scss">
#lab-documents-file-view {
  .breadcrumbs {
    padding: 5px 0 15px;
    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #273480;
        text-transform: uppercase;
        font-size: 14px;
      }
      .el-breadcrumb__separator {
        color: #000000;
      }
    }
  }
  .name-accession {
    display: flex;
    align-items: center;
    .order-files {
      padding-right: 10px;
      img {
        position: relative;
        top: 4px;
        width: 22px;
        height: 22px;
      }
    }
    .order-files-name-value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      color: black;
      text-align: left !important;
      width: 400px;
    }
  }
  .grid-view-block {
    margin-top: 15px;
    .grid-scroll {
      height: calc(100vh - 200px);
      overflow: auto;
      .single-grid-view-block {
        display: grid;
        grid-template-columns: repeat(6, 15.5%);
        -moz-column-gap: 15px;
        column-gap: 10px;
        row-gap: 20px;
        @media (min-width: 1200px) and (max-width: 1450px) {
          grid-template-columns: repeat(5, 15%);
          -moz-column-gap: 15px;
          column-gap: 28px;
          row-gap: 30px;
        }
        @media (min-width: 1600px) {
          display: grid;
          grid-template-columns: repeat(7, 13.25%);
          -moz-column-gap: 15px;
          column-gap: 15px;
          row-gap: 20px;
        }

        .single-grid-view-block-col {
          background: #ffffff;
          border: 1.28012px solid #e0e0e0;
          border-radius: 3.84035px;
          padding: 10px;
          .icon-block {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            img {
              width: 60px;
              height: 60px;
              padding: 0.5rem 0;
            }
            .action-buttons {
              .folder-btn {
                border: none;
                padding: 0;
                &:hover {
                  border: none;
                  background: transparent;
                }
                &:active {
                  border: none;
                  background: transparent;
                }
                &:focus {
                  border: none;
                  background: transparent;
                }
                img {
                  width: 28px;
                  height: 30px;
                  padding: 0;
                }
              }
            }
          }
          .content {
            padding: 0.5rem 0 0 0.5rem;

            h4 {
              font-size: 14px;
              color: #25213b;
              font-weight: 500;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .sub-text {
              font-size: 14px;

              color: rgba(37, 33, 59, 0.7);
              font-weight: 500;
              .file-size {
                padding: 1.5rem 0 0.5rem;
              }
            }
          }
        }
      }
    }
  }
  .upload-files-alignment-block {
    .upload-files-alignment {
      width: 100%;
      margin: auto;
      margin-bottom: 10px;
    }
    .sample-attachment-upload-file-block {
      .sample-attachment-upload-file {
        li {
          .file-name-attachment {
            display: inline-flex;
            align-items: center;
            padding: 7px 5px 7px 0px;
            border: 0.5px solid #e0e0e0;
            border-radius: 5px;
            height: 20px;
            min-width: 30%;
            max-width: 96%;
            margin: 0;
            img {
              padding: 0 10px;
              height: 15px;
              width: 15px;
            }
            p {
              color: #4f4f4f;
              white-space: nowrap;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .el-button {
              .without-hover {
                display: none;
                transition: all 0.2s ease-in-out;
              }
              .hover {
                display: block;
                transition: all 0.2s ease-in-out;
              }
              &:hover {
                .without-hover {
                  display: block;
                  transition: all 0.2s ease-in-out;
                }
                .hover {
                  display: none;
                  transition: all 0.2s ease-in-out;
                }
              }
            }
          }
        }
      }
    }
  }
  .labdocfileslisting{
    .el-table__body-wrapper{
      overflow-y: auto!important;
    }
  }
  .default-modal {
    .popup-date {
      .el-upload {
        width: 100%;
      }
      .el-upload-dragger {
        width: 100%;
        margin: auto;
        height: 120px;
        background: #c4c4c41f;

        border: 0.6px dashed #c4c4c41f;
        border-radius: 6px;
      }
      .el-upload-text-align {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .el-upload__text-img {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            padding: 0 10px;
          }
        }
        .el-upload-text {
          line-height: 14px;
          h3 {
            color: #333333;
            font-size: 18px;
          }
          p {
            color: #828282;
            font-size: 18px;
          }
        }
      }
    }
  }
  .no-data-block {
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    text-align: center;
    background-color: #fff;
    padding: 15px;
    .bg-image {
      text-align: center;
      .bg-image {
        width: 350px;
      }
    }
    .no-data-content {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 20px;
      margin-top: 55px;

      h3 {
        text-transform: uppercase;
        font-size: 22px;
        color: #BF1B39;
        padding-right: 5px;
      }
    }
  }
}
</style>
